import React from 'react';
import { Link } from 'react-router-dom';
import type { ProductCtaBannerConfig } from '../../../product-subpage/types';

export const PlatformCtaBanner: React.FC<{ banner: ProductCtaBannerConfig }> = ({
  banner,
}) => (
  <section className="platform-cta-banner" aria-label={banner.ctaLabel}>
    <div className="platform-cta-banner__inner">
      <div className="platform-cta-banner__content">
        <h3 className="platform-cta-banner__title">{banner.title}</h3>
        <div className="platform-cta-banner__actions">
          <Link className="platform-cta-banner__btn" to={banner.ctaTo}>
            {banner.ctaLabel}
          </Link>
        </div>
      </div>
      {banner.imageSrc && (
        <div className="platform-cta-banner__art" aria-hidden>
          <img src={banner.imageSrc} alt={banner.imageAlt ?? ''} loading="lazy" />
        </div>
      )}
    </div>
  </section>
);
